import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ToastSeverity = 'info' | 'success' | 'warning' | 'error';

export interface ToastMessage {
  id: number;
  text: string;
  severity: ToastSeverity;
}

/**
 * Lightweight, dependency-free transient toast notifications. Rendered by ToastHostComponent.
 */
@Injectable({ providedIn: 'root' })
export class ToastService {
  private nextId = 1;
  private readonly toastsSource = new BehaviorSubject<ToastMessage[]>([]);
  readonly toasts$ = this.toastsSource.asObservable();

  show(text: string, severity: ToastSeverity = 'info', ttlMs = 6000): void {
    const toast: ToastMessage = { id: this.nextId++, text, severity };
    this.toastsSource.next([...this.toastsSource.value, toast]);
    setTimeout(() => this.dismiss(toast.id), ttlMs);
  }

  dismiss(id: number): void {
    this.toastsSource.next(this.toastsSource.value.filter((t) => t.id !== id));
  }
}
